import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import { Element } from 'react-scroll/modules';

import log_blanco from '../../../assets/images/2022/Patrocinadores/Ies_AcuityBrands.png';

import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_acuitybrands.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';


const Acuty = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a onClick={()=> { onMetrica('video',nombre); }} href="#video">
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores"><span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
          <br /><strong>
          Acuity Brands posee el portafolio de productos de iluminación y controles más completo para todas las aplicaciones de interior y exterior. Como la empresa líder de Iluminación tenemos lo que necesitas. 
        </strong><br /><br />
        Nuestro portafolio con más de un millón de productos configurables con simples dimmers hasta redes de control de iluminación sofisticadas para integrar a los sistemas de gestión de edificios.
        <br /><br />
        Ofrecemos soluciones de iluminación que se adapten en algún espacio en cualquier lugar. Aplicamos nuestra capacidad de liderazgo en la industria para conocer tus requerimientos específicos de iluminación, ya sea para una habitación o un campus completo.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          <strong>
          Acuity Brands has the most comprehensive portfolio of lighting and controls products for all indoor and outdoor applications. As the leading lighting company we have what you need.
          </strong><br /><br />
          Our portfolio with more than a million products configurable from simple dimmers to sophisticated lighting control networks to integrate with building management systems.
          <br /><br />
          We offer lighting solutions that fit in any space anywhere. We apply our industry leadership skills to meet your specific lighting requirements, be it for a room or an entire campus.
        </p>
        }

        </Col>
        <Col span={16} offset={4}>
        <br />
        <div className="contenedor_video_patrocinador" onClick={()=>onMetrica('video',nombre)}>
        <iframe className="video" src="https://www.youtube.com/embed/19PhR3BP0Fg?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen onClick={()=>onMetrica('video',nombre)} ></iframe>
          </div>
        
          {/*<a href="https://www.youtube.com/watch?v=19PhR3BP0Fg" target="_blank"><img src={img_vdo} style={{width:'100%'}} alt="video" /></a>*/}
          <br /><br />
        </Col>
        <Element name="#video"/>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href={idioma === 'es' ? 'https://api.whatsapp.com/send?phone=525578787025&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Acuity%20Brands%20de%20la%20IES.' : 'https://api.whatsapp.com/send?phone=525579035865&text=Hi,%20contact%20me%20from%20the%20Acuity%20Brands%20booth%20at%20IES.'} onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}>
            {idioma === 'es' ?
            <img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" />
            :
            <img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" />
            }
          </a>
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:cynthia.barrera@acuitybrands.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}>
          {idioma === 'es' ?
          <img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" />
        :
        <img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" />}
          </a>
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
          
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Qué marcas se encuentran en el portafolio de Acuity Brands?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Tenemos un amplio portafolio de productos para ti. Conoce nuestras marcas:
                  <br />Lithonia Lighting, Gotham, Peerless, Juno, Mark Architectural Lighting, Healthcare Lighting, Winona, Hydrel, Aculux, A-Light, Luminis, Eureka, Cyclone, nLight, nLight Air, Distech Controls, Holophane, American Electric Lighting, entre otras.
                    </p>
            </Panel>
            :
            <Panel header="What brands are in the Acuity Brands portfolio?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  We have a wide portfolio of products for you. Get to know our brands:
                  <br /><br />
                  Lithonia Lighting, Gotham, Peerless, Juno, Mark Architectural Lighting, Healthcare Lighting, Winona, Hydrel, Aculux, A-Light, Luminis, Eureka, Cyclone, nLight, nLight Air, Distech Controls, Holophane, American Electric Lighting, among others.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Dónde se fabrican sus luminarios?" key="2" className="panel_patrocinador">
              <p className="texto_patrocinadores">
              Acuity Brands cuenta con 23 plantas de fabricación, en México contamos diversos centros de producción y distribución ubicados en el estado Nuevo León en los municipios de Apodaca y Guadalupe y en el estado de Tamaulipas en el municipio de Matamoros.
              <br /><br />
              Nuestra planta de Guadalupe cuenta con 4 naves industriales que en conjunto suman más de 79,700m2 de producción, con más de 7,500 empleados, en las cuales se fabrican y ensamblan luminarios, componentes y sensores, siendo la planta de fabricación más grande de todo el mundo en el ramo de iluminación con una producción de más de 170,000 luminarios diarios.
                </p>
            </Panel>
            :
            <Panel header="Where are your luminaires manufactured?" key="2" className="panel_patrocinador">
              <p className="texto_patrocinadores">
              Acuity Brands has 23 manufacturing plants, in Mexico we have various production and distribution centers located in the state of Nuevo León in the municipalities of Apodaca and Guadalupe and in the state of Tamaulipas in the municipality of Matamoros.
              <br /><br />
              Our plant in Guadalupe has 4 industrial warehouses that together add up to more than 79,700m2 of production, with more than 7,500 employees, in which luminaires, components and sensors are manufactured and assembled, being the largest manufacturing plant in the world. in the field of lighting with a production of more than 170,000 lights per day.
                </p>
            </Panel>}
           {idioma === 'es' ?
            <Panel header="¿Dónde puedo conocer sus luminarios?" key="3" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Contamos con un showroom en la Ciudad de México donde puedes conocer nuestros productos y sistemas de controles. 
            <br />
            <a target="_blank" className="texto_patrocinadores_link" href="http://maps.apple.com/maps?q=2,+Los+Morales+Polanco+11510">Visítanos en Jaime Balmes 8 PB L 1 y 2, Los Morales Polanco, 11510,  CDMX.</a>
              </p>
            </Panel>
            :
            <Panel header="Where can I find out about your luminaries?" key="3" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We have a showroom in Mexico City where you can learn about our products and control systems.
            <br />
            <a target="_blank" className="texto_patrocinadores_link" href="http://maps.apple.com/maps?q=2,+Los+Morales+Polanco+11510">Visit us at Jaime Balmes 8 PB L 1 and 2, Los Morales Polanco, 11510, CDMX..</a>
              </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde puedo contactarlos?" key="4" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Puedes escribirnos a <a target="_blank" className="texto_patrocinadores_link" href="mailto:marketinglatam@acuitybrands.com">marketinglatam@acuitybrands.com </a>
            <br />
            o al teléfono <a target="_blank" className="texto_patrocinadores_link" href="tel:+525550291617">(55) 5029 1617</a>
              </p>
            </Panel>
            :
            <Panel header="Where can I contact you?" key="4" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            You can write to us at <a target="_blank" className="texto_patrocinadores_link" href="mailto:marketinglatam@acuitybrands.com ">marketinglatam@acuitybrands.com </a>
            <br />
            or by phone <a target="_blank" className="texto_patrocinadores_link" href="tel:+525550291617">(55) 5029 1617</a>
              </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/AcuityBrandsLatinoamerica" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('linkedin',nombre)} href="https://www.linkedin.com/company/acuity-brands-latinoamerica/" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_lk_hover : btn_lk} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="https://www.youtube.com/channel/UC8Ym-WoSmzOHmCJN1LtjFcA?view_as=subscriber" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href=" https://www.instagram.com/acuitybrandslatinoamerica/?hl=es-la" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Acuty;